import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { ColorName } from '@panaya/ui/styles-to-code';
import { PDialogFooterBtnConfig } from './p-dialog-footer-btn-config.interface';

@Component({
    selector: 'p-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header
                title="{{ headerText }}"
                [iconName]="headerIcon"
                [iconColor]="headerIconColor"
                [isSentenceCase]="isSentenceCase"
            ></p-dialog-header>
            <ng-content></ng-content>
            <p-dialog-footer [btnConfig]="btnConfig">
                <div *ngIf="footerTemplate">
                    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                </div>
            </p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PDialogComponent {
    @Input() headerText? = '';
    @Input() headerIcon? = '';
    @Input() headerIconColor!: ColorName;
    @Input() isSentenceCase? = true;
    @Input() btnConfig: PDialogFooterBtnConfig[] = [];
    @Input() footerTemplate?: TemplateRef<HTMLElement>;
}
